<template>        
    <a :href="routes.overview" class="cart-button">
        <span style="position:absolute" class="amount">{{ count }}</span>
        <img src="/dist/assets/images/icons/heart.svg" alt="heart icon" draggable="false" uk-svg>
        <span>Verlanglijstje</span>
    </a>
</template>

<script>    
    import { EventBus } from "../EventBus";

    export default {
        name: "WishlistIcon",        
        mounted() {
            EventBus.$on('WISHLIST_UPDATE', wishlist => {
                this.count = wishlist.productsCount;
            });
        },
        data() {
            return {
                count: this.initCount ?? 0
            };
        },
        props: {
            translations: {
                type: Object,
                required: false,
                default() { return  {}; }
            },
            initCount: String|Number,
            routes: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>